import { api } from './index';

export const subscriptionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIsSubscribed: build.query({
      query: () => `/is-subscribed`,
      providesTags: ['subscribed'],
    }),
    unsubscribe: build.mutation({
      query() {
        return {
          url: `/unsubscribe`,
          method: 'POST',
        }
      },
      invalidatesTags: [{type: 'subscribed'}],
    }),
    subscribe: build.mutation({
      query() {
        return {
          url: `subscribe`,
          method: 'POST',
        }
      },
      invalidatesTags: [{type: 'subscribed'}],
    }),
  }),
});

export const {
  useGetIsSubscribedQuery,
  useSubscribeMutation,
  useUnsubscribeMutation,
} = subscriptionApi;
